import { FirestoreDataConverter, QueryDocumentSnapshot, serverTimestamp, SnapshotOptions, Timestamp, WithFieldValue } from 'firebase/firestore';
import { BaseAppEntity, BaseFirestoreEntity } from '../../types/baseTypes';

export interface OcdInfoFirestore extends BaseFirestoreEntity {
  userProvided: string[];
  inferred: string[];
}

export interface OcdInfo extends BaseAppEntity {
  userProvided: string[];
  inferred: string[];
}

export interface LearningQuestionFirestore extends BaseFirestoreEntity {
  question: string;
  answers: string[];
}

export interface LearningQuestion extends BaseAppEntity {
  question: string;
  answers: string[];
}

//converter between firestore and app types

export const learningQuestionConverter: FirestoreDataConverter<LearningQuestion, LearningQuestionFirestore> = {
  toFirestore(learningQuestion: LearningQuestion): WithFieldValue<LearningQuestionFirestore> {
    return {
      question: learningQuestion.question,
      answers: learningQuestion.answers,
      createdAt: learningQuestion.createdAt ? Timestamp.fromDate(learningQuestion.createdAt) : serverTimestamp(),
      updatedAt: serverTimestamp(),
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): LearningQuestion {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      question: data.question,
      answers: data.answers,
      createdAt: (data.createdAt as Timestamp).toDate(),
      updatedAt: (data.updatedAt as Timestamp).toDate(),
    };
  },
};

export const ocdInfoConverter: FirestoreDataConverter<OcdInfo, OcdInfoFirestore> = {
  toFirestore(ocdInfo: OcdInfo): WithFieldValue<OcdInfoFirestore> {
    return {
      createdAt: ocdInfo.createdAt ? Timestamp.fromDate(ocdInfo.createdAt) : serverTimestamp(),
      updatedAt: serverTimestamp(),
      userProvided: ocdInfo.userProvided,
      inferred: ocdInfo.inferred,
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): OcdInfo {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      createdAt: (data.createdAt as Timestamp).toDate(),
      updatedAt: (data.updatedAt as Timestamp).toDate(),
      userProvided: data.userProvided,
      inferred: data.inferred,
    };
  },
};

export interface OcdProfile {
  ocdInfos: { [key: string]: OcdInfo };
  learningQuestions: LearningQuestion[];
}
